const whiteList = ['/login']
export default whiteList
